import * as React from 'react';
import { IPhotoGallery } from './interfaces';
import {
  Box,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from '@mui/material';
import { groupByDate } from './helpers';
import { formatLocaleDate } from '@helpers/dateHelpers';
import InfoIcon from '@mui/icons-material/Info';
import { ContentTitle } from '../ContentTitle';

export const PhotoGallery: React.FC<IPhotoGallery> = ({
  photos,
}): JSX.Element => {
  const groupedPhotos = groupByDate(photos);

  return (
    <Box>
      {Object.entries(groupedPhotos).map(([date, photoGroup]) => (
        <Box key={date} sx={{ mb: 4 }}>
          <ContentTitle
            align="left"
            variant="small"
            title={formatLocaleDate(photoGroup.date, false)}
          />

          {/* Foto Grid */}
          <ImageList variant="quilted" cols={3} gap={8}>
            {photoGroup.photos.map((photo) => (
              <ImageListItem
                key={photo.title}
                sx={{
                  position: 'relative',
                  '&:hover .MuiImageListItemBar-root': {
                    opacity: 1,
                  },
                }}
              >
                <img
                  src={photo.source}
                  alt={photo.title}
                  loading="lazy"
                  style={{
                    // borderRadius: '8px',
                    width: '100%',
                    objectFit: 'cover',
                  }}
                />
                <ImageListItemBar
                  title={photo.title}
                  subtitle={formatLocaleDate(photo.date, false)}
                  actionIcon={
                    <IconButton
                      sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                      aria-label={`info about ${photo.title}`}
                    >
                      <InfoIcon />
                    </IconButton>
                  }
                  sx={{
                    opacity: 0,
                    transition: 'opacity 0.3s',
                  }}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
      ))}
    </Box>
  );
};
